import request from "root/js/request";

export const getProductCardStockDynamic = async ({
  cabinet_id__in,
  date_from,
  date_to,
  period,
  in_product_id,
  in_product_id__in,
  extra_fields,
  source,
  source__in,
  in_size_id,
  in_size_id__in,
  warehouse__in,
  group_by,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/card_stock_dynamic/",
    method: "get",
    params: {
      cabinet_id__in,
      date_from,
      date_to,
      period,
      in_product_id,
      in_product_id__in,
      extra_fields,
      source,
      source__in,
      in_size_id,
      in_size_id__in,
      warehouse__in,
      group_by,
      ...rest,
    },
  });
  return response.data;
};
